import { render, staticRenderFns } from "./AiHelperBall.vue?vue&type=template&id=23185ca3&scoped=true"
import script from "./AiHelperBall.vue?vue&type=script&lang=js"
export * from "./AiHelperBall.vue?vue&type=script&lang=js"
import style0 from "./AiHelperBall.vue?vue&type=style&index=0&id=23185ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23185ca3",
  null
  
)

export default component.exports